import React from 'react';

const FallbackUI = () => {
  return <section className="fallback-ui">Something went wrong.</section>;
};

export default FallbackUI;
